<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-tabs v-model="tab" grow>
        <v-tab>学员账号</v-tab>
        <v-tab>教练账号</v-tab>
        <v-tab>管理员账号</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model.trim="name"
                :rules="nameRules"
                label="姓名"
                required
                @input="handleNameInput"
              ></v-text-field>

              <v-text-field
                v-model.trim="account"
                :rules="accountRules"
                label="账号"
                required
                @input="handleAccountInput"
              ></v-text-field>

              <v-text-field
                v-model.trim="password"
                :rules="passwordRules"
                label="密码"
                type="password"
                required
                @input="handlePasswordInput"
              ></v-text-field>

              <v-text-field
                v-model.trim="email"
                :rules="emailRules"
                label="电子邮箱"
                required
                @input="handleEmailInput"
              ></v-text-field>

              <v-text-field
                v-model="phone"
                label="电话号码"
                :rules="phoneRules"
                required
              ></v-text-field>

              <v-autocomplete
                v-model="channel"
                :rules="channelRules"
                :items="channels"
                item-text="name"
                item-value="id"
                label="来源渠道"
                required
              ></v-autocomplete>

              <v-menu
                ref="startMenu"
                v-model="startMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedEnabledTime"
                    label="启用时间"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="enabledDate"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="startMenu = false">取消</v-btn>
                  <v-btn text color="primary" @click="showStartTimePicker">
                    选择时间
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="startTimeMenu"
                v-model="startTimeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <v-time-picker
                  v-if="startTimeMenu"
                  v-model="enabledTime"
                  full-width
                  format="24hr"
                  use-seconds
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="startTimeMenu = false">取消</v-btn>
                  <v-btn text color="primary" @click="saveStartTime">
                    确定
                  </v-btn>
                </v-time-picker>
              </v-menu>

              <v-menu
                ref="endMenu"
                v-model="endMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="formattedExpiredTime"
                    label="有效期限"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="expiredDate"
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="endMenu = false">取消</v-btn>
                  <v-btn text color="primary" @click="showEndTimePicker">
                    选择时间
                  </v-btn>
                </v-date-picker>
              </v-menu>

              <v-menu
                ref="endTimeMenu"
                v-model="endTimeMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
              >
                <v-time-picker
                  v-if="endTimeMenu"
                  v-model="expiredTime"
                  full-width
                  format="24hr"
                  use-seconds
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="endTimeMenu = false">取消</v-btn>
                  <v-btn text color="primary" @click="saveEndTime">
                    确定
                  </v-btn>
                </v-time-picker>
              </v-menu>
            </v-form>
          </v-card-text>
        </v-tab-item>

        <!-- 教练账号和管理员账号的 tabs 可以在这里添加类似的内容 -->
      </v-tabs-items>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">取消</v-btn>
        <v-btn color="blue darken-1" text @click="submitForm">提交</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userApi } from '@/api/user'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      dialog: false,
      tab: null,
      valid: true,
      name: "",
      account: "",
      password: "",
      email: "",
      phone: "",
      channel: null,
      enabledDate: null,
      enabledTime: null,
      expiredDate: null,
      expiredTime: null,
      channels: [],
      accountRules: [
        v => !!v || "账号是必填项",
        v => (v && v.length >= 8) || "账号至少需要8个字符",
        v => /^[a-zA-Z0-9@._]+$/.test(v) || "账号只能包含英文字母、数字、@、_ 和 ."
      ],
      passwordRules: [
        v => !!v || "密码是必填项",
        v => (v && v.length >= 8) || "密码至少需要8个字符",
        v => /^[a-zA-Z0-9@._]+$/.test(v) || "密码只能包含英文字母、数字、@、_ 和 ."
      ],
      nameRules: [
        v => !!v || "姓名是必填项",
        v => v.length <= 50 || "姓名不能超过50个字符"
      ],
      emailRules: [
        v => !!v || "电子邮箱是必填项",
        v => /.+@.+\..+/.test(v) || "请输入有效的电子邮件地址",
        v => /^[a-zA-Z0-9@._]+$/.test(v) || "邮箱只能包含英文字母、数字、@、_ 和 ."
      ],
      channelRules: [
        v => {
          return v !== null && v !== undefined || "来源渠道是必填项"
        }
      ],
      phoneRules: [
        v => !!v || '请输入电话号码',
        v => /^[0-9]{11}$/.test(v) || '请输入有效的电话号码'
      ],
      startMenu: false,
      startTimeMenu: false,
      endMenu: false,
      endTimeMenu: false,
    };
  },
  computed: {
    formattedEnabledTime() {
      if (!this.enabledDate || !this.enabledTime) return ''
      return this.formatDateTime(this.enabledDate, this.enabledTime)
    },
    formattedExpiredTime() {
      if (!this.expiredDate || !this.expiredTime) return ''
      return this.formatDateTime(this.expiredDate, this.expiredTime)
    }
  },
  async created() {
    await this.fetchChannels()
  },
  methods: {
    showStartTimePicker() {
      this.startMenu = false;
      this.$nextTick(() => {
        this.startTimeMenu = true;
      });
    },

    showEndTimePicker() {
      this.endMenu = false;
      this.$nextTick(() => {
        this.endTimeMenu = true;
      });
    },

    saveStartTime() {
      this.startTimeMenu = false;
    },

    saveEndTime() {
      this.endTimeMenu = false;
    },

    formatDateTime(date, time) {
      if (!date || !time) return '';
      return dayjs(`${date} ${time}`).format('YYYY-MM-DD HH:mm:ss');
    },

    async fetchChannels() {
      try {
        const response = await userApi.getUserSourceChannels()
        this.channels = response.data.userSourceChannels
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取渠道列表失败：' + errorMessage);
      }
    },

    resetForm() {
      this.$refs.form.reset();
      this.name = '';
      this.account = '';
      this.password = '';
      this.email = '';
      this.phone = '';
      this.channel = null;
      this.enabledDate = null;
      this.enabledTime = null;
      this.expiredDate = null;
      this.expiredTime = null;
      this.valid = true;
    },

    handleNameInput(value) {
      this.name = value.replace(/[^\u4e00-\u9fa5a-zA-Z0-9\s_]/g, '').trim();
    },

    handleAccountInput(value) {
      this.account = value.replace(/[^a-zA-Z0-9@._]/g, '');
    },

    handlePasswordInput(value) {
      this.password = value.replace(/[^a-zA-Z0-9@._]/g, '');
    },

    handleEmailInput(value) {
      this.email = value.replace(/[^a-zA-Z0-9@._]/g, '');
    },

    async submitForm() {
      if (!this.$refs.form.validate()) return;

      try {
        const accountData = {
          name: this.name.trim(),
          account: this.account.trim(),
          password: this.password.trim(),
          email: this.email.trim(),
          phone: this.phone.trim(),
          channelId: this.channel,
          enabledTime: this.formattedEnabledTime,
          expiredTime: this.formattedExpiredTime
        };

        switch (this.tab) {
          case 0: // 学员账号
            await userApi.createJobSeekerAccount(accountData);
            break;
          case 1: // 教练账号
            await userApi.createCoachAccount(accountData);
            break;
          case 2: // 管理员账号
            await userApi.createAdminAccount(accountData);
            break;
        }

        this.$emit('refresh-list');
        this.dialog = false;
        this.$toast.success('账号创建成功');
        this.resetForm();
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('创建失败：' + errorMessage);
      }
    }
  },
};
</script>